module.exports = __webpack_public_path__ + "img/small.94940d1c.png";